<template>
    <b-modal
        id="modal-ingredientproduction"
        size="xl"
        ref="modal"
        :title="formtitle"
        :visible="visible"
        @hidden="hide"
        @ok="handleOk"
        @change="change"
    >
        <b-alert v-model="showDismissibleAlert" variant="danger" dismissible>
            {{ alertText }}
        </b-alert>
        <b-tabs card>
            <card-prep-production
                :inItem="localItem"
                :editAllowed="allowEdit"
                @input="setProductieIngredient"
                @changed="setChanged"
                @selectedNaam="setProductieIngredientNaam"
            />
        </b-tabs>
    </b-modal>
</template>

<script>
import { loadItem, loadList } from '../../models/DataHelper';
import Helper from '../../models/Helper';
import { IngredientProduction } from '../../models/Recept';
import CardPrepProduction from './CardPrepProduction.vue';

export default {
    name: 'IngredientProductionModal',
    data: function () {
        return {
            showDismissibleAlert: false,
            alertText: '',
            nieuw: false,
            localItem: null
        };
    },
    model: {
        prop: 'visible',
        event: 'change'
    },
    props: {
        inItem: {
            type: IngredientProduction,
            default: null
        },
        visible: {
            type: Boolean,
            default: false
        },
        allowEdit: {
            type: Boolean,
            default: true
        }
    },
    components: { CardPrepProduction },
    watch: {},
    computed: {
        formtitle() {
            if (this.localItem == undefined) return '??';
            if (this.nieuw) {
                return Helper.stringformat(
                    '{0} {1}: {2}',
                    this.$t('com_new', { ns: 'common' }),
                    this.$t('com_production', { ns: 'common' }),
                    this.localItem.naam ?? '??'
                );
            } else {
                return Helper.stringformat(
                    '{0}: {1} ({2})',
                    this.$t('prod_prodgegvoor', { ns: 'production' }),
                    this.localItem.naam ?? '??',
                    this.localItem.batchID ?? '??'
                );
            }
        }
    },
    methods: {
        showAlert(tekst) {
            this.alertText = tekst;
            this.showDismissibleAlert = true;
        },
        setProductieIngredient(productie) {
            this.localItem = productie;
        },
        setProductieIngredientNaam(naam) {
            this.localItem.naam = naam;
        },
        hide() {
            this.$emit('hide');
        },
        change(visible) {},
        async awaitcheckTotaalIngredienten() {
            let totaalHH = 0;
            let doClose = true;
            for (let i = 0; i < this.localItem.elementen.length; i++) {
                // tel kilos en liters gewoon bij elkaar op
                const ing = this.localItem.elementen[i];
                const unit = this.$store.getters['components/getUnitbyID'](
                    ing.eenheid
                );
                const ingHH = ing.hoeveelheid * (unit?.factor ?? 1);
                totaalHH += ingHH;
            }
            this.ingredientenHH = Helper.Round(totaalHH, 3);
            if (this.localItem.hoeveelheid) {
                const min = this.ingredientenHH * 0.9;
                const max = this.ingredientenHH * 1.1;
                const amountSeemsGood =
                    this.localItem.hoeveelheid > min &&
                    this.localItem.hoeveelheid < max;
                if (!amountSeemsGood) {
                    // vraag bevestiging of afwijking klopt
                    doClose = await this.$root.showConfirmationBox(
                        Helper.stringformat(
                            this.$t('prod_hhmorethansum', {
                                ns: 'production'
                            }),
                            this.localItem.hoeveelheid,
                            this.ingredientenHH
                        )
                    );
                }
            }
            return doClose;
        },
        setChanged() {
            this.isChanged = true;
        },
        checkFormValidity() {
            const invalidBasis = this.localItem.CheckValidity(this.$t);
            if (invalidBasis) {
                this.showAlert(invalidBasis);
                return false;
            }
            return true;
        },
        handleOk(bvModalEvt) {
            // Prevent modal from closing
            bvModalEvt.preventDefault();
            // Trigger submit handler
            this.handleSubmit();
        },
        async handleSubmit() {
            // Exit when the form isn't valid
            if (!this.checkFormValidity()) {
                return;
            }
            if (!(await this.awaitcheckTotaalIngredienten())) {
                return;
            }
            await this.saveThisProduction();
            this.$emit('changed');
            // Hide the modal manually
            this.$nextTick(() => {
                this.$bvModal.hide('modal-ingredientproduction');
            });
        },
        async saveThisProduction() {
            this.localItem.isChanged = true;
            const saveProduction = this.localItem.SetForSave();
            loadItem(
                'preparation/saveIngredientProduction',
                saveProduction,
                this.$t
            );
        }
    },
    mounted() {},
    created() {
        const templijst = loadList(
            'components/getUnitsComboLijst',
            'components/loadUnitsComboLijst',
            null,
            false,
            this.$t
        );
        this.localItem = this.inItem ? this.inItem : new IngredientProduction();
        this.nieuw =
            this.localItem.voorraadID == undefined ||
            this.localItem.voorraadID < 0;
    }
};
</script>

<style scoped></style>
